import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {IdexService} from '../../../idex.service';
import {TranslateService} from '@ngx-translate/core';
import {Toast} from '../../../shared/toast/toast';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { IncludeAuditTrailComponent } from '../include-audit-trail/include-audit-trail.component';

declare var $: any;

@Component({
   selector: 'app-view-document',
   templateUrl: './view-document.component.html',
   styleUrls: ['./view-document.component.css']
})
export class ViewDocumentComponent {
   @Input() isFormName: boolean;
   @Input() sections: any;
   @Input() docIds;
   @Input() docId;
   @Input() flagSign;
   @Input() mimType;
   @Input() flagdownload;
   @Input() disableButtonSign;
   @Input() checkloaded;
   @Input() canNotFound;
   @Input() show = true;
   @Input() viewMode = false;
   @Input() signMenuClick: any;
   @Input() isHideCommentPdf;
   @Input() enableButtonAnnotate: boolean;
   @Input() typeName;
   @Input() taskStatus;
   @Output() onzoomInEvent = new EventEmitter<any>();
   @Output() onseparateDownload = new EventEmitter<any>();
   @Output() onzoomOutEvent = new EventEmitter<any>();
   @Output() onprintEvent = new EventEmitter<any>();
   @Output() onrotateEvent = new EventEmitter<any>();
   @Output() ondownloadAll = new EventEmitter<any>();
   @Output() ondownloadEvent = new EventEmitter<any>();
   @Output() viewForm = new EventEmitter<any>();
   public canZoomIn = true;
   public canZoomOut = false;
   public lastDocId;
   public isCompleteTask = false;
   public taskId;
   includeAuditTrialDialog : MatDialogRef<IncludeAuditTrailComponent>;

   constructor(private _service: IdexService,
               public translate: TranslateService,
               public toast: Toast, private dialog: MatDialog) {

   }

   download() {
      const tId = this.taskId === undefined ? 0 : this.taskId;
      location.href = this._service.url + '/downloadAdmin?id=' + this.docId.docId + '&token=' + this._service.user.token +
         '&taskId=' + tId + '&device=Web' + '&email=' + this._service.user.email;
   }

   downloadAll(flagStatisComplete?:Boolean) {
      if(flagStatisComplete){
         this.includeAuditTrialDialog = this.dialog.open(IncludeAuditTrailComponent, {
            disableClose: true,
            data: {}
          });

          this.includeAuditTrialDialog.afterClosed().subscribe(result => {
            if(result){
               this.actionDownloadAll(this.includeAuditTrialDialog.componentInstance.includeAuditTrail)
            }else{
               this.ondownloadAll.emit();
            }
         });
      }else{
         this.actionDownloadAll(false);
      }

   }

   actionDownloadAll(flagInclude:Boolean){
      const listIds = [];
      const token = this._service.user.token;
      if (this.docIds) {
         for (const itemSel of this.docIds) {
            if (itemSel.docName !== 'Document not found') {
               if (!this.taskStatus) {
                  if (!itemSel.isForm && !itemSel.docName.endsWith('.zdox')) {
                     listIds.push(itemSel.docId);
                  }
               } else {
                  listIds.push(itemSel.docId);
               }
            }
         }
      }
      if (listIds.length > 0) {
         this._service.post('/multiple/download/task?taskId=' + this.taskId + '&device=Web' + '&email=' + this._service.user.email + '&includeAuditTrail=' + flagInclude, listIds)
            .subscribe({
               next: data => {
                  location.href = this._service.url +  '/zip/download?path=' + encodeURIComponent(data.file)
                     + '&token=' + token;
                  this.ondownloadAll.emit();
               },
               // enable the Download menu again, otherwise Download All / Combine Download stay disabled
               error: () => this.ondownloadAll.emit()
            });
      } else {
         this.handleToastError('menu.errorDownload');
         this.ondownloadAll.emit();
      }
   }

   downloadCombine(taskName,flagStatisComplete?:Boolean) {
      if(flagStatisComplete){
         this.includeAuditTrialDialog = this.dialog.open(IncludeAuditTrailComponent, {
            disableClose: true,
            data: {}
          });

         this.includeAuditTrialDialog.afterClosed().subscribe(result => {
            if(result){
               this.actionDownloadCombine(taskName,this.includeAuditTrialDialog.componentInstance.includeAuditTrail)
            }else{
               this.ondownloadAll.emit();
            }
         });
      }else{
         this.actionDownloadCombine(taskName,false)
      }

   }

   actionDownloadCombine(taskName,flagInclude:Boolean){
      const docs = [];
      for (const doc of this.docIds) {
         if (doc.docName !== 'Document not found') {
            if (!this.taskStatus) {
               if (!doc.isForm && !doc.docName.endsWith('.zdox')) {
                  docs.push(doc.docId);
               }
            } else {
               if (this.docIds.length > 1) {
                  if (!doc.isForm && !doc.docName.endsWith('.zdox')) {
                     docs.push(doc.docId);
                  }
               } else {
                  docs.push(doc.docId);
               }
            }
         }
      }
      if (docs.length > 0) {
         location.href = this._service.url + '/downloadCombineAdmin?taskName=' +
            taskName + '&docIds=' + docs.toString() + '&token=' + this._service.user.token +
            '&taskId=' + this.taskId + '&device=Web' + '&email=' + this._service.user.email+ '&includeAuditTrail=' + flagInclude + '&lang='+this.translate.currentLang;
         setTimeout(() => {
            this.ondownloadAll.emit();
         }, 1000);
      } else {
         this.handleToastError('menu.errorDownload');
         this.ondownloadAll.emit();
      }
   }

   onPrint($event) {
      this.onprintEvent.emit($event);
   }

   onZoomIn($event) {
      this.onzoomInEvent.emit($event);
   }

   onZoomOut($event) {
      this.onzoomOutEvent.emit($event);
   }

   onRotateRight($event) {
      this.onrotateEvent.emit('right');
   }

   onRotateLeft($event) {
      this.onrotateEvent.emit('left');
   }

   onDownload($event) {
      this.ondownloadEvent.emit(this.docId.docId);
   }

   handleToastError(key, msgList?) {
      this.translate.get(key).subscribe((msg) => {
         if (msgList) {
            this.toast.error(msg + msgList);
         } else {
            this.toast.error(msg);
         }
      });
   }
   switchView($event){
      this.viewForm.emit(this.docId.docId);
   }
}
